import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import LdsVideoPlayer from "../../components/LdsVideoPlayer";
import LdsFigureCaption from "../../components/LdsFigureCaption";
import LdsKalturaPlayer from "../../components/LdsVideoPlayer/KalturaPlayer";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_2_1_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              2.3.6 Demonstration Case 4: A More Difficult Positive Scan
            </h1>
            <p className="me-4">Estimated time to complete: 3 minutes</p>
          </section>

          <section className="row justify-content-center">
            <div className="col-lg-8 col-sm-12 mt-4 mb-4">
              <LdsFigureCaption
                textContent={
                  <>
                    <p>
                      <strong>AUDIO</strong>
                      <br />
                      VO: (FEMALE)
                      <br />
                    </p>
                    <p>
                      This is Demonstration Case Number 4. This is a positive
                      case. The size and contrast have already been adjusted.
                    </p>
                    <p>
                      Starting at the bottom of the brain, and in the
                      cerebellum, we can identify the normal gray- white
                      contrast for this patient. Moving superiorly and into the
                      temporal and occipital regions, it is immediately obvious
                      that the white matter tracts are not clearly delineated.
                      In this case, the loss of gray-white contrast is patchy on
                      both sides, as can be seen here and here.
                    </p>
                    <p>
                      Moving superiorly, but remaining in the temporal-occipital
                      region, white matter tracts are more easily identifiable
                      at this level bilaterally. In addition, less intense gray
                      matter activity is seen surrounding the white matter
                      tracts. However, overall there are multiple patchy regions
                      of loss of gray-white contrast in the temporal and
                      occipital lobes which extend over more than one slice and
                      include more than one gyrus. Moving superiorly into the
                      frontal lobes, there is complete loss of gray-white
                      contrast. The expected, normal, white matter, finger-like
                      projections are not identified on the right or the left on
                      this scan; therefore, there is loss of gray-white contrast
                      in the frontal lobes.
                    </p>
                    <p>
                      Again, moving superiorly and entering into the parietal
                      region, it is clear that there is loss of gray-white
                      contrast, with increased activity extending to the
                      periphery in multiple regions, as identified here and
                      here. This pattern also continues superiorly here.
                    </p>
                    <p>
                      In the medial parietal region, there is increased activity
                      in the gray matter, as can be seen on the left and the
                      right. Increased gray matter uptake in both medial
                      parietal lobes appears to extend to the midline. This
                      pattern of increased uptake is abnormal.
                    </p>
                    <p>
                      Returning to the temporo-occipital region, if there
                      remains concern about this particular region, the coronal
                      slices may help. As can be seen in this coronal slice,
                      there is increased activity extending to the periphery in
                      this temporal region. On the left-hand side, this pattern
                      can also be seen here. As there is a loss of gray-white
                      contrast bilaterally, the temporal lobes are positive.
                    </p>
                    <p>
                      So, although the areas of loss of gray-white contrast were
                      patchy in the temporal and occipital lobes, overall they
                      were abnormal. In addition, the frontal and parietal
                      cortices, including the medial parietal region, showed
                      decreased gray-white contrast.
                    </p>
                    <p>
                      This scan is, therefore, positive for moderate to frequent
                      Amyloid neuritic plaques.
                    </p>
                  </>
                }
                buttonIcon="MinusCircle"
                buttonTextAlign="left"
                showDescriptionText="Video Transcript"
                hideDescriptionText="Video Transcript"
                radiusSize="small"
              >
                <LdsVideoPlayer brandBorder={false}>
                  <LdsKalturaPlayer
                    videoId="1_d2otwmj4"
                    partnerId="1759891"
                    uiConfId="54959122"
                    nextUrl="/module-2/module-2-3-7"
                  />
                </LdsVideoPlayer>
              </LdsFigureCaption>
            </div>
          </section>

          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-2/module-2-3-5", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              id="next"
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              disabled={true}
            >
              Next Lesson
            </LdsButton>
          </section>
        </main>
      </div>
    </div>
  );
};

export default Module_2_1_1;
